import { type IAdminHeaderLogoProps } from '@framework/theme/admin/AdminHeaderLogo.tsx';
import { HeaderLogo } from '@framework/ui/components/layout/header/HeaderLogo.tsx';
import { down } from 'styled-breakpoints';
import styled, { useTheme } from 'styled-components';

const LogoWrapper = styled.div`
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: start;

  ${down('sm')} {
    max-width: 150px;
  }
`;

/**
 * Logo principale dell'applicativo.
 */
export function AdminHeaderLogo(props: IAdminHeaderLogoProps) {
  const theme = useTheme();

  return <HeaderLogo {...theme} logoWrapperComponent={LogoWrapper} />;
}
